import "core-js/stable";
import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { init as SentryInit, reactRouterV6Instrumentation } from '@sentry/react';
import org_model from 'models/org_model'  // for some reason, import this here removes a cycling dependency loading issue in webpack
import {
	useLocation,
	useNavigationType,
	createRoutesFromChildren,
	matchRoutes,
} from "react-router-dom";

import App from "App";
// import Main from "Main";
// import MobileMain from "MobileMain";

SentryInit( {
				dsn: "https://ae7078f7e1e747fe8c142143e6b150c9@o1275977.ingest.us.sentry.io/6471274",
				maxBreadcrumbs: 150,
				release: __RELEASE__,
				// debug:true,
				// tracesSampleRate: 1.0,
				ignoreErrors: [],
				// denyUrls: ['http://localhost:9011'],
				// integrations: [
				// 	new BrowserTracing({
				// 		//tracingOrigins: ['api.wewordle.com'],  // Note: needs to authorise `sentry-trace` header on API first (in Access-Control-Allow-Headers)
				// 		routingInstrumentation: reactRouterV6Instrumentation(
				// 			useEffect,
				// 			useLocation,
				// 			useNavigationType,
				// 			createRoutesFromChildren,
				// 			matchRoutes,
				// 		)
				// 	})
				// ],
				beforeSend(event,hint) {
					const code = hint?.originalException?.code 
					/**
					 * Expanding list of non-errors
					 * 
					 * https://firebase.google.com/docs/reference/js/v8/firebase.auth.Auth
					 */
					if (code && ['auth/invalid-email','auth/user-disabled','auth/user-not-found','auth/wrong-password','auth/invalid-verification-code','auth/missing-email','auth/expired-action-code','auth/captcha-check-failed','auth/cancelled-popup-request','auth/popup-blocked','auth/user-token-expired','auth/account-exists-with-different-credential','auth/multi-factor-auth-required','auth/invalid-custom-token','auth/invalid-credential','auth/popup-closed-by-user'].includes(code))
						return null
						
					return event
				}
			} );
			
import firebaseApp from 'xAppLib/providers/firebase.js';
import { getPerformance } from "firebase/performance";
// const perf = 
getPerformance(firebaseApp);
// console.log('perf', perf);
// const trace = perf.trace('WebAppRuns');
// console.log('trace', trace);
// trace.start();
// console.log('WebAppRuns');
const menu = document.getElementById('main-menu')
menu?.remove()
const content = document.getElementsByClassName('cms-page').item(0)
window.___ = {loc:location.pathname.replace(/\/$/,''),content:content&&content.innerHTML}

ReactDOM.render(
	<App />,
	// app.settings.is_mobile && <MobileMain /> || <App />,
	document.getElementById('app')
);

// trace.stop();
